class ImageLoader extends HTMLElement {
  #img;
  #observer;

  connectedCallback() {
    this.#img = this.querySelector('img');
    //console.log('ss: ', this.#img)
    if (!this.#img) return;
    this.#bind();
    if (this.hasAttribute('observe')) this.#observe();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
  
  #rmLoading(){
    return this.removeAttribute('loading');
  }

  #bind() {
    const img = this.#img;

    this.removeAttribute('loaded');
    this.removeAttribute('error');
    this.setAttribute('loading', '');
    //this.removeAttribute('lazy');

    if (img.complete) {
      //console.log('complete 2')
      this.removeAttribute('lazy');
      this.#rmLoading();
      return this.setAttribute(img.naturalWidth > 0 ? 'loaded' : 'error', '');
    }

    img.addEventListener('load', () => {
        //console.log('load 2')
        this.#rmLoading();
        this.setAttribute('loaded', '');
      },
      { once: true }
    );

    img.addEventListener('error', () => {
        //console.log('error 2')
        this.#rmLoading();
        this.setAttribute('error', '');
      },
      { once: true }
    );
  }

  #observe() {
    this.#observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if ( mutation.attributeName === 'src' || mutation.attributeName === 'srcset' ) {
          this.#bind();
          break;
        }
      }
    });

    this.#observer.observe(this.#img, {
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });
  }
}
customElements.define('hdt-image-loader', ImageLoader);